/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Benefits_Testimonial_QuoteInputs */

const en_mobile_benefits_testimonial_quote = /** @type {(inputs: Mobile_Benefits_Testimonial_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`“I was honestly drowning in readings, 3+ hours a day. Now I get through all my readings in under an hour! Thank you!”`)
};

const es_mobile_benefits_testimonial_quote = /** @type {(inputs: Mobile_Benefits_Testimonial_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`“Honestamente me estaba ahogando en lecturas, más de 3 horas al día. ¡Ahora termino todas mis lecturas en menos de una hora! ¡Gracias!”`)
};

/**
* | output |
* | --- |
* | "“I was honestly drowning in readings, 3+ hours a day. Now I get through all my readings in under an hour! Thank you!”" |
*
* @param {Mobile_Benefits_Testimonial_QuoteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_benefits_testimonial_quote = /** @type {((inputs?: Mobile_Benefits_Testimonial_QuoteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Benefits_Testimonial_QuoteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_benefits_testimonial_quote(inputs)
	return en_mobile_benefits_testimonial_quote(inputs)
});